import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {OVERHEAD_CAMERA} from "../../util/RouteConstants";
import OverheadCameraDeviceOverviewContextProvider from "./context/OverheadCameraDeviceOverviewContext";

class OverheadCameraDevicePage extends Component {
    render() {
        const getOverheadCameraRoutes = () => {
            return OVERHEAD_CAMERA;
        }

        return (
            <Column>
                <OverheadCameraDeviceOverviewContextProvider>
                    <TabLayout routes={getOverheadCameraRoutes()} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={getOverheadCameraRoutes()}/>
                </OverheadCameraDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default OverheadCameraDevicePage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/OverheadCameraDevicePage.js